module.exports = __webpack_public_path__ + "img/location.928e3ca.png";